export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/identification_perseus/contact_seller_checkout.a0afce2.png";